import { Localizations } from "../Shared/sharedTypes";

export function handleGetUserMediaError(
    err: Error,
    localizations: Localizations,
    setCameraAndMicPermissionStatus?: (permissionState: PermissionState) => void,
) {
    console.log(err);
    if (err.name === "NotFoundError" || err.name === "DevicesNotFoundError") {
        alert(localizations.MicOrCameraNotFound);
        setCameraAndMicPermissionStatus && setCameraAndMicPermissionStatus("prompt");
    } else if (err.name === "NotReadableError" || err.name === "TrackStartError") {
        alert(localizations.MicOrCameraInUse);
        setCameraAndMicPermissionStatus && setCameraAndMicPermissionStatus("prompt");
    } else if (err.name === "OverconstrainedError" || err.name === "ConstraintNotSatisfiedError") {
        alert(localizations.MicOrCameraUnsupported);
        setCameraAndMicPermissionStatus && setCameraAndMicPermissionStatus("prompt");
    } else if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
        setCameraAndMicPermissionStatus && setCameraAndMicPermissionStatus("denied");
    } else if (err.name === "TypeError" || err.name === "TypeError") {
        alert(localizations.ConfigurationIssueFound);
        setCameraAndMicPermissionStatus && setCameraAndMicPermissionStatus("prompt");
    } else {
        alert(localizations.ConfigurationIssueFound);
        setCameraAndMicPermissionStatus && setCameraAndMicPermissionStatus("prompt");
    }
}
